// @flow

import ApiObject from './ApiObject';
import Product from './menu/Product';

export default class Check extends ApiObject {

  id: string = '';

  tableNumber: string = '';

  subtotal: number = 0;

  tax: number = 0;

  total: number = 0;

  outstandingBalance: number = 0;

  guestcount: number = 0;

  currency: string = ''; // TODO

  date: number = 0; // TODO

  posCheckId: string = ''; // equals to checkId who will be removed

  /**
   * Restaurant name
   */
  restaurant: string = '';

  serveurFirstName: string = '';

  serveurFullName: string = '';

  serveurLastName: string = '';

  tips: number = 0;

  total: number = 0;

  /**
   * Serializable: 'entries'. TODO
   */
  entries: Array<Product> = [];

  postJsonAssignation(data: Object) {
    super.postJsonAssignation(data);

    // -- deserialize payments
    // this.entries = []
    // _.each(data.entries, (dataEntry:Object) => {
    //   const entry:
    //   this.entries.push(entry);
    // });
  }

}
